import { useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import { fileDownload } from 'utils';
import api from 'client';

export default (selectedConversationId, initialMessageId) => {
  const queryClient = useQueryClient();

  const reply = async ({ message, attachments = [] }) => {
    const data = new FormData();
    if (message) {
      data.append('body', `<p>${message}</p>`);
    }
    if (attachments.length > 0) {
      attachments.forEach((file) => {
        data.append('files[]', file);
      });
    }
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return api.post(`/apis/v2/messages/${initialMessageId}/reply_all`, data, config).catch((err) => {
      toast.error(() => err.response?.data?.meta?.attachment || err.message);
    });
  };

  const mutation = useMutation(reply, {
    onSuccess: () => {
      queryClient.invalidateQueries(['GET', `/apis/v2/messages/${selectedConversationId}`, {}]);
      queryClient.invalidateQueries(['GET', '/apis/v2/messages/inbox', { per: 10 }]);
    },
  });

  const [downloadingList, setDownloadingList] = useState([]);

  const download = (messagesId, attachmentId, attachmentName) => {
    setDownloadingList((list) => [...list, attachmentId]);
    return api
      .get(`/apis/v2/messages/${messagesId}/attachments/${attachmentId}`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, attachmentName, { newWindow: true, mime: response.headers['content-type'] });
      })
      .catch((err) => {
        if (err.response?.data?.invalidParams?.blob) {
          toast.error(() => err.response?.data?.invalidParams?.blob);
        } else if (err.response?.data?.message) {
          toast.error(() => err.response?.data?.message);
        } else {
          toast.error(() => err.message);
        }
        queryClient.invalidateQueries(['GET', `/apis/v2/messages/${messagesId}`, {}]);
      })
      .finally(() => {
        setDownloadingList((list) => list.filter((item) => item !== attachmentId));
      });
  };

  return {
    reply: mutation.mutate,
    download,
    downloadingList,
  };
};
